<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="direction: rtl;display: flex !important;">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="جستجو..." autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div [ngStyle]="{'direction' : lang == 2 ? 'ltr' : 'rtl'}" class="service_pager">
            <span>
                <button (click)='open_detaile(0,1,0)' class="new1" [disabled]='new_status'
                    *ngIf="lang == 1">جديد</button>
                <button (click)='open_detaile(0,1,0)' class="new1" [disabled]='new_status' *ngIf="lang == 2"
                    [ngClass]="{en_navigation_number:lang==2}">New</button>

                <button (click)='open_detaile(0,3,0)' *ngIf="lang == 1" class="search1">جستجو</button>
                <button (click)='open_detaile(0,3,0)' *ngIf="lang == 2" [ngClass]="{en_navigation_number:lang==2}"
                    class="search1">Search</button>
                <a id="download" href="{{ site }}/export/{{ export_code }}.xlsx" *ngIf="show_excel == true">
                    <button [ngClass]="{en_navigation_number:lang==2}">
                        <span *ngIf="lang == 2">Excel</span>
                        <span *ngIf="lang == 1">خروجی اکسل</span>
                    </button>
                </a>
                <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                        class="fas fa-fast-forward"></i></button>
                <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                        class="fas fa-forward"></i></button>
                <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                        class="fas fa-backward"></i></button>
                <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                        class="fas fa-fast-backward"></i></button>
                <div class='navigation' [ngClass]="{en_navigation_number:lang==2}"><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="material-icons pager_icons cursor" (click)="check_access(3,0,selected_record,1,1)">
                delete
            </div>
            <div style="display: inline-block;">
                <mat-checkbox (change)="get_select($event.checked)" [(indeterminate)]="indeterminate"></mat-checkbox>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
    style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'
        [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
        [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">
        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                <span *ngIf="lang == 1">ردیف</span>
                <span *ngIf="lang == 2">#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + page_number_first }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="material">
            <mat-header-cell *matHeaderCellDef style="min-width:300px;">
                <span *ngIf=" lang==1">عنوان کالا</span>
                <span *ngIf="lang == 2">Order Title</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)"
                style="min-width:300px;direction: rtl" class="right">
                <div class="right">{{ x.wharehouse_material_title }}</div>
            </mat-cell>
        </ng-container>


        <ng-container matColumnDef="number">
            <mat-header-cell *matHeaderCellDef style="max-width: 70px;">
                <span *ngIf="lang == 1">تعداد</span>
                <span *ngIf="lang == 2">Order Title</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)"
                style="max-width: 70px;">
                {{ x.wharehouse_order_number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="cost">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">قیمت واحد</span>
                <span *ngIf="lang == 2">Order Title</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)">
                {{ x.wharehouse_order_cost | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="sum">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">قیمت کل</span>
                <span *ngIf="lang == 2">Order Title</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)">
                {{ x.sum | number }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="supplier">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">تامین کننده</span>
                <span *ngIf="lang == 2">Supplier</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)">
                {{ x.supplier_name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="currency">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">واحد پولی</span>
                <span *ngIf="lang == 2">Currency</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)">
                {{ x.site_currency_title }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="invoice">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1"> ش فاکتور </span>
                <span *ngIf="lang == 2"> Invoice </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)">
                <span>{{ x.wharehouse_invoice_number }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="reception">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1">شماره پذیرش</span>
                <span *ngIf="lang == 2">Reception number</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)">
                {{ x.wharehouse_order_reception }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>
                <span *ngIf="lang == 1"> وضعیت </span>
                <span *ngIf="lang == 2"> order Status</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_order_id)">
                <span>{{ x.wharehouse_order_status_title }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sort">
            <mat-header-cell *matHeaderCellDef [hidden]="true">
                <span *ngIf="lang == 1">ترتیب</span>
                <span *ngIf="lang == 2">Sort</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" [hidden]="true"
                (click)="open_detaile(i,2,x.wharehouse_order_id)">{{ x.wharehouse_order_sort }}</mat-cell>
        </ng-container>


        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:90px'>
                <span *ngIf="lang == 1"> عملیات </span>
                <span *ngIf="lang == 2">Operation</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:90px'>
                <mat-checkbox (change)="get_select_records(i)" name="selete_records[]" [value]="x.wharehouse_order_id"
                    [checked]="x.checked" class="hidden-sm hidden-xs"></mat-checkbox>
                <span (click)='open_detaile(i,2,x.wharehouse_order_id)'><i class="fas fa-desktop icon"></i></span>
                <span (click)="delete_get_material(x.wharehouse_order_id,x.wharehouse_order_material)"><i
                        class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span>
            </mat-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor" [ngStyle]="{'backgroundColor':row.wharehouse_order_status_color}"></mat-row>

    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview.png">
            </div>
            <div class="preview2">{{ no_record }}</div>
        </div>
    </div>
</div>